(function() {
	'use strict';

	angular.module('paxMessage').config(config);

	function config($stateProvider) {
		$stateProvider.state('paxMessage', {
			url : '/pax-message',
			views : {
				'paxMessageView' : {
					templateUrl : 'pax-message/views/pax-message.tpl.html',
					controller : 'PaxMessageCtrl',
					controllerAs : 'paxMessage'
				}
			}

		});
	}
}());
